import {Col, Row, FormGroup, Input, Label} from "reactstrap";
import React from "react";
import Nouns from "./Nouns";

const ThreeParInputs = ({
                       device,
                       port,
                       handleInputChange,
                       lgColSize,
                   }) => {
    if (Nouns.threeParDevices.includes(device?.trim().toUpperCase())) {
        return (
            <Row>
                <Col lg={lgColSize} sm={6}>
                    <FormGroup>
                        <Label htmlFor="port">Port</Label>
                        <Input
                            required={false}
                            type="text"
                            name="port"
                            value={port}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
        );
    } else {
        return null;
    }
};
export default ThreeParInputs;